<!--
 * @ Author: Your name
 * @ Create Time: 2019-06-21 16:07:43
 * @ Modified by: Your name
 * @ Modified time: 2019-08-07 10:07:00
 * @ Description: 退料记录 弹窗
 -->
<template>
  <div class="dialog-wrapper">
    <el-form :model="dialogFormData" label-width="108px" :rules="rules"
      label-position="right" ref="dialogForm"
      v-loading="formLoading" class="dialog-form" :inline="true">
      <div>
        <el-form-item label="变更前手机号">
          <el-input
            size="small" v-model="receivePersonPhone"
            placeholder="变更前手机号" disabled/>
        </el-form-item>
        <el-form-item label="变更后手机号" prop="exchangePhone">
          <el-input
            size="small" v-model="dialogFormData.exchangePhone"
            placeholder="变更后手机号" clearable />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import dialog from '../../mixins/dialog'
import { correctPhone } from '../../libs/utils/validCheck'

export default {
  mixins: [dialog],
  props: {
    receivePersonPhone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formLoading: false,
      dialogFormData: {
        exchangePhone: '',
        exchangeStatus: 2
      },
      rules: {
        exchangePhone: [{ required: true, message: '请输入修改领取人手机号', trigger: 'change' },
          { validator: correctPhone, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper{
  text-align: center;
}
</style>
